import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  convertToSearchField,
  generateColumnMetadata,
} from "../../utils/utils";
import DataGrid from "../../components/common/dataGrid/dataGrid";
import { commonPostApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { mask } from "primereact/utils";
import {
  nonRequirePatientListField,
  DonorReportColumns,
} from "../../utils/serviceData";
import { useSelector } from "react-redux";
import { exportCSV, exportExcel, exportPdf } from "../../utils/exportUtils";
import PrimaryHeader from "../../components/common/primaryHeader";
import { SORT_ORDER } from "../../constants/sortOrder";

export default function DoctorReportList() {
  const navigate = useNavigate();
  const user = useSelector((state) => state?.common?.user);
  const [columns, setColumns] = useState([]);
  const searchFields = ["patient_name", "first_name", "patient_code"];
  const [loading, setLoading] = useState(true);
  const [dataGridShow, setDataGridShow] = useState(false);
  const [dashboardData, setDoctorDashBoard] = useState({});
  const [dataGridSelectOption, setDataGirdSelectOption] = useState(1);
  const [values, setValues] = useState([]);
  const [navigator, setNavigator] = useState({
    page: 1,
    first: 0,
    rows: 10,
    totalRecords: 1,
    sortBy: "patient_name",
    sortDir: SORT_ORDER.ASC,
    searchCriteria: convertToSearchField(searchFields, ""),
  });
  const init = async (navigator) => {
    let currentObj = {
      page: navigator?.page,
      limit: navigator?.rows,
      sortFields: [[navigator?.sortBy, navigator?.sortDir]],
      searchCriteria: navigator?.searchCriteria,
      user_id: user?.user_id,
    };
    await commonPostApi(API_ENDPOINTS.DOCTOR_REPORT, currentObj)
      .then((data = []) => {
        if (data?.data) {
          const finalData = data?.data;
          const updatedPatient = finalData.map((p) => ({
            ...p,
            aadhar_no: mask(p.aadhar_no),
          }));
          setNavigator((prev) => ({
            ...prev,
            totalRecords: data?.data?.total,
            page: data?.data?.currentPage,
          }));
          setColumns(
            generateColumnMetadata({
              data: finalData,
              nonRequireField: [
                ...nonRequirePatientListField,
                "patient_visit_id",
              ],
              alias: {
                patient_name: "patient",
                patient_code: "patient_id",
                aadhar_no: "aadhaar_no",
              },
              defaultColumnsArr: DonorReportColumns,
            })
          );
          setValues(
            updatedPatient?.map((item) => {
              const { aadhar_no, ...rest } = item;
              return rest;
            }) || []
          );
          setLoading(false);
        } else {
          setNavigator((prev) => ({
            ...prev,
            totalRecords: 1,
            page: 1,
          }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  function onPageChange(event) {
    setLoading(true);
    setNavigator((prev) => ({
      ...prev,
      first: event?.first,
      page: event.page + 1,
    }));
    init({
      ...navigator,
      first: event?.first,
      page: event.page + 1,
    });
  }

  const onRowCountChange = (e) => {
    setLoading(true);
    setNavigator((prev) => ({
      ...prev,
      rows: e?.target?.value,
      page: 1,
      first: 0,
    }));
    init({
      ...navigator,
      page: 1,
      first: 0,
      rows: e?.target?.value,
    });
  };

  const fetchDoctorReport = async (payload = { filterType: "today" }) => {
    await commonPostApi(API_ENDPOINTS.DOCTOR_REPORT, payload).then((data) => {
      setDoctorDashBoard(data?.data);
    });
  };

  const onSortClick = (event) => {
    setLoading(true);
    const sortOrder = event?.sortOrder === 1 ? SORT_ORDER.ASC : SORT_ORDER.DESC;
    setNavigator((prev) => ({
      ...prev,
      sortBy: event?.sortField,
      sortDir: sortOrder,
      sortFields: [[event?.sortField, sortOrder]],
    }));
    init({
      ...navigator,
      sortBy: event?.sortField,
      sortDir: sortOrder,
      sortFields: [[event?.sortField, sortOrder]],
    });
  };

  const generatePayload = (date1, date2, selectedOption, dataGrid) => {
    const filterType = {
      1: "today",
      2: "week",
      3: "month",
      4: "custom",
    };
    const payload = {};
    payload.startDate = date1;
    payload.endDate = date2;
    payload.filterType = filterType[selectedOption];
    if (dataGrid === "dataGrid") {
      setNavigator((prev) => {
        init({
          ...prev,
          ...payload,
        });
        return {
          ...prev,
          ...payload,
        };
      });
    } else {
      fetchDoctorReport(payload);
    }
  };

  useEffect(() => {
    init(navigator);
  }, [user?.user_id]);

  const handleRowClick = (rowData) => {
    console.log("Row clicked:", rowData);
    navigate(`/reports/doctor/treatment/${rowData.data.patient_id}`);
  };

  function handleSearchChange(value) {
    setNavigator((prev) => ({
      ...prev,
      searchCriteria: convertToSearchField(searchFields, value),
    }));
    init({
      ...navigator,
      searchCriteria: convertToSearchField(searchFields, value),
    });
  }

  return (
    <div className=" pt-3">
      <DataGrid
        header={
          <PrimaryHeader
            isCalenderEnabled={true}
            isDownloadButton={true}
            exportCSV={() => exportCSV(values, columns, "Doctor_Patient_List")}
            exportExcel={() =>
              exportExcel(values, columns, "Doctor_Patient_List")
            }
            exportPdf={() => exportPdf(values, columns, "Doctor_Patient_List")}
            isSearchEnabled={true}
            searchPlaceHolder={"Search Patients"}
            searchHeaderLable={"Patient List"}
            onChange={handleSearchChange}
            show={dataGridShow}
            onDateRangeChange={(date1, date2, selectedOption = 1) => {
              generatePayload(date1, date2, selectedOption, "dataGrid");
            }}
            setShow={setDataGridShow}
            selectOption={dataGridSelectOption}
            setSelectOption={setDataGirdSelectOption}
          />
        }
        onSortClick={onSortClick}
        onRowCountChange={onRowCountChange}
        onPageChange={onPageChange}
        sortable={true}
        navigator={navigator}
        column={columns}
        value={values}
        loading={loading}
        isAccordionEnabled={false}
        isPaginatorEnabled={true}
        onRowClick={handleRowClick}
        isRowClickEnabled={true}
      />
    </div>
  );
}
